import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureScenarioReleaseHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/visual-game/admin' })
}

function client() {
  if (http === null) throw new Error('configureScenarioReleaseHttp must be called before scenario release API use')
  return http
}

export async function getScenarioRelease(scenarioId) {
  return client().get(`/scenario-releases/${encodeURIComponent(scenarioId)}`, {
    routeId: 'visualGame.scenarioRelease.detail',
  })
}

export async function publishScenarioToProduction(scenarioId, sourceVersionId) {
  return client().post(`/scenario-releases/${encodeURIComponent(scenarioId)}/production`, {
    body: { source_version_id: sourceVersionId },
    routeId: 'visualGame.scenarioRelease.publishProduction',
  })
}
